export function capitalize(value: string) {
    return value[0].toUpperCase() + value.substring(1);
}

export function arrayEqual<T>(arr: T[], arr2: T[]) {
    if (arr.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
}
